export const usePersonalType = () => {
    const route = useRoute();

    const type = computed(() => {
        if (route.path.startsWith('/profile-clinic')) return 'clinic';
        if (route.path.startsWith('/profile-doctor')) return 'doctor';
        return 'client';
    });

    const rootPath = computed(() => {
        switch (type.value) {
            case 'clinic': return '/profile-clinic/';
            case 'doctor': return '/profile-doctor/';
            default: return '/profile/';
        }
    });

    return { type, rootPath };
};